import React from 'react';

export const ErrorNotFoundIcon = () => (
  <svg
    width="100%"
    height="auto"
    viewBox="0 0 806 408"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18006_22987)">
      <rect
        width="806"
        height="407"
        transform="translate(0 0.5)"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M493.581 322.569C485.596 333.319 475.915 342.794 464.473 349.751C424.026 374.346 378.536 389.151 335.367 381.227C282.48 371.518 243.749 336.571 222.448 291.172C197.589 238.191 177.171 174.955 212.507 119.377C248.685 62.4749 310.408 58.4586 384.111 67.742C448.488 56.7477 488.849 -3.97808 559.908 32.9212C629.804 83.3468 563.491 159.385 546.773 216.147C534.367 258.264 531.051 272.124 493.581 322.569Z"
        fill="#EBF6FF"
      />
      <path
        d="M328.218 284.161L328.222 284.167L328.227 284.173C341.959 303.732 361.901 313.467 387.608 313.467C404.809 313.467 419.474 309.158 431.41 300.363L431.424 300.353L431.438 300.342C443.318 291.38 452.165 278.536 458.081 262.019C464.19 245.315 467.195 225.194 467.195 201.736C467.195 166.507 460.603 139.175 446.977 120.176C433.425 100.999 413.472 91.4929 387.608 91.4929C370.61 91.4929 355.97 95.6995 343.855 104.264L343.844 104.271L343.834 104.278C331.919 112.849 322.962 125.512 316.845 142.027L316.841 142.037L316.837 142.047C310.923 158.362 308.021 178.389 308.021 202.034C308.021 237.085 314.62 264.588 328.218 284.161ZM414.629 258.933L414.62 258.95L414.611 258.968C411.64 264.818 407.92 269.04 403.518 271.814C399.122 274.583 393.86 276.025 387.608 276.025C381.464 276.025 376.249 274.587 371.846 271.814C367.433 269.033 363.659 264.798 360.587 258.933C354.396 247.116 351.118 228.193 351.118 201.736C351.118 175.259 354.403 156.676 360.557 145.487L360.562 145.478L360.567 145.468C363.629 139.808 367.394 135.714 371.808 133.021C376.217 130.332 381.446 128.935 387.608 128.935C393.878 128.935 399.155 130.337 403.556 133.021C407.959 135.707 411.669 139.79 414.63 145.433L414.644 145.46L414.659 145.487C420.812 156.676 424.097 175.259 424.097 201.736C424.097 228.193 420.819 247.116 414.629 258.933Z"
        fill="white"
        stroke="#27B0E0"
        strokeWidth="6.19105"
      />
      <path
        d="M96.5674 307.367H709.433V393.523H96.5674V307.367Z"
        fill="white"
      />
      <path
        d="M184.834 307.291L469.258 307.291"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M277.967 345.26L358.789 345.26"
        stroke="#EBF6FF"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M144.422 341.787L225.244 341.787"
        stroke="#EBF6FF"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M521.664 376.333L602.486 376.333"
        stroke="#EBF6FF"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M592.623 330.321L673.445 330.321"
        stroke="#EBF6FF"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M358.789 376.333L439.611 376.333"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M386.555 328.105L529.316 328.105"
        stroke="#EBF6FF"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M673.445 307.291H704.555"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M447.419 350.445H478.528"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M225.244 328.105H290.74"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M265.07 366.476L290.74 366.476"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M373.53 341.787L399.2 341.787"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M529.316 341.787H567.605"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M481.928 307.291H626.795"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M89.1602 307.291H120.27"
        stroke="#27B0E0"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M574.462 307.367C568.771 306.029 564.67 303.463 562.159 299.669C559.693 295.686 559.151 290.754 560.535 284.873L565.755 262.678L495.471 246.147C489.59 244.764 485.138 242.416 482.114 239.102C479.279 235.833 478.486 231.542 479.736 226.231C480.45 223.195 481.989 220.054 484.354 216.807C486.909 213.604 490.965 209.553 496.522 204.654L601.058 110.025C604.651 106.666 608.305 104.323 612.021 102.995C615.737 101.666 619.681 101.493 623.855 102.475C628.787 103.635 632.508 106.112 635.02 109.905C637.575 113.509 638.117 118.441 636.644 124.701L609.271 241.082L623.214 244.362C628.716 245.656 632.482 247.943 634.513 251.223C636.779 254.359 637.331 258.392 636.171 263.325C635.011 268.257 632.696 271.716 629.226 273.703C625.99 275.544 621.622 275.818 616.12 274.524L602.177 271.245L596.957 293.44C595.574 299.32 592.891 303.494 588.907 305.96C584.968 308.237 580.153 308.706 574.462 307.367ZM572.849 232.516L593.73 143.736L601.982 145.677L511.672 228.337L513.947 218.662L572.849 232.516Z"
        fill="#27B0E0"
      />
      <path
        d="M256.715 307.72C250.995 308.927 246.192 308.347 242.307 305.981C238.381 303.423 235.794 299.189 234.547 293.278L229.839 270.969L159.193 285.878C153.282 287.126 148.254 286.892 144.108 285.178C140.152 283.424 137.611 279.877 136.485 274.538C135.841 271.487 135.899 267.989 136.66 264.045C137.612 260.06 139.561 254.669 142.508 247.873L196.913 117.786C198.737 113.218 201.049 109.544 203.848 106.762C206.646 103.981 210.143 102.147 214.338 101.262C219.296 100.216 223.717 100.876 227.603 103.242C231.448 105.419 234.034 109.653 235.362 115.945L260.05 232.925L274.065 229.967C279.595 228.8 283.976 229.27 287.209 231.376C290.592 233.251 292.807 236.667 293.853 241.625C294.899 246.583 294.274 250.698 291.977 253.971C289.831 257.013 285.993 259.118 280.463 260.285L266.449 263.243L271.157 285.552C272.404 291.463 271.749 296.381 269.192 300.307C266.594 304.041 262.435 306.513 256.715 307.72ZM223.44 240.651L204.607 151.415L212.902 149.664L166.288 262.871L164.235 253.146L223.44 240.651Z"
        fill="#27B0E0"
      />
    </g>
    <defs>
      <clipPath id="clip0_18006_22987">
        <rect
          width="806"
          height="407"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
